import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'

const BATCHED_EVENT_LIMIT = {
  [TELEMETRY_EVENT_NAMES.BULK_PRODUCT_CARD_VIEW]: 8,
}

export default BATCHED_EVENT_LIMIT
